import ActionType from "../constants/ActionTypes";

export const changeLanguage = (languageCode, translations) => ({
  type: ActionType.CHANGE_LANGUAGE,
  payload: {
    locale: languageCode,
    messages: translations.messages
  }
});